import {
    CREATE_POINT_OF_INTEREST_IMAGE,
    CREATE_POINT_OF_INTEREST_IMAGE_FAILURE,
    CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS,
} from 'store/actions/types';

export const createPointOfInterestImage = (payload) => {
    return {
        type: CREATE_POINT_OF_INTEREST_IMAGE,
        payload: payload,
    };
};

export const createPointOfInterestImageFailure = (error) => {
    return {
        type: CREATE_POINT_OF_INTEREST_IMAGE_FAILURE,
        error: error,
    };
};

export const createPointOfInterestImageSuccess = (payload, response) => {
    return {
        type: CREATE_POINT_OF_INTEREST_IMAGE_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/images/createPointsOfInterestImage.js